module.exports = __webpack_public_path__ + "img/icon_gray.10eb4cc0.png";